import { CustomAction } from 'model/state';
import {
  FETCH_UNIT_DETAILS, FETCH_UNIT_DETAILS_SUCCESS, FETCH_UNIT_DETAILS_ERROR, CLEAN_UNIT_DETAILS, SET_CURRENT_DEVICE,
  REFRESH_UNIT_DETAILS_SUCCESS, START_TELEMETRY_POLLING, STOP_TELEMETRY_POLLING
} from 'constants/ActionTypes';
import { Unit } from 'model';

/**
 * Payload
 */
export interface UnitPayload {
  unitId?: string;
  unit?: Unit;
  macAddress?: string;
}

/**
 * Actions
 */
export const fetchUnitDetails = (unitId: string): CustomAction<UnitPayload> => {
  return {
    type: FETCH_UNIT_DETAILS,
    payload: { unitId }
  };
};

export const fetchUnitDetailsSuccess = (unit: Unit): CustomAction<UnitPayload> => {
  return {
    type: FETCH_UNIT_DETAILS_SUCCESS,
    payload: { unit }
  };
};

export const fetchUnitDetailsError = (): CustomAction<UnitPayload> => {
  return {
    type: FETCH_UNIT_DETAILS_ERROR,
  };
};

export const cleanUnitDetails = (): CustomAction<UnitPayload> => {
  return {
    type: CLEAN_UNIT_DETAILS,
  };
};

export const setCurrentDevice = (macAddress: string): CustomAction<UnitPayload> => {
  return {
    type: SET_CURRENT_DEVICE,
    payload: { macAddress }
  };
};

export const startTelemetryPolling = (unitId: string): CustomAction<UnitPayload> => {
  return {
    type: START_TELEMETRY_POLLING,
    payload: { unitId }
  };
};

export const stopTelemetryPolling = (): CustomAction<UnitPayload> => {
  return {
    type: STOP_TELEMETRY_POLLING,
  };
};

export const refreshUnitDetailsSuccess = (unit: Unit): CustomAction<UnitPayload> => {
  return {
    type: REFRESH_UNIT_DETAILS_SUCCESS,
    payload: { unit }
  };
};